import { components } from "swagger/types";

export enum ETaxonomy {
  ApprovalStatus = "ApprovalStatus",
  ConsentType = "ConsentType",
  Country = "Country",
  Currency = "Currency",
  DependentType = "DependentType",
  EligibleType = "EligibleType",
  PaymentMethod = "PaymentMethod",
  PaymentType = "PaymentType",
  EligibleDateType = "EligibleDateType",
  OffboardingType = "OffboardingType",
  OffboardingDateType = "OffboardingDateType",
  Gender = "Gender",
  SicCode = "SicCode",
  DeliveryType = "DeliveryType",
  AttachmentType = "AttachmentType",
}

export enum IConsentDeliveryType {
  UploadScan = "DeliveryType.UPLOAD_SCAN",
  PaperToInsurer = "DeliveryType.PAPER_TO_INSURER",
  PaperToGreco = "DeliveryType.PAPER_TO_GRECO",
}

export enum EInsurerConsentType {
  INSURER_FORM = 1,
  URL_TO_INSURER = 2,
  I_AGREE_TEXT = 3,
}
export interface INotification {
  fieldName?: string;
  text: string;
  id: string;
  handleClearNotification?: (message: INotification) => void;
  type: "error" | "info" | "warning" | "success";
  // notify: INotify;
}

export interface INotify {
  notifyText: string;
  type: string;
  notifyCode: string;
  label: string;
}

export interface IErrorHandler {
  value: string;
  type: string;
  label: string;
  fieldName?: string;
  errors?: any;
}

export enum ECheckedValue {
  Yes = "yes",
  No = "no",
}

export type SelectItem = {
  text: string;
  value: string | number;
  Icon?: JSX.Element;
  [x: string]: any;
};

export type IFormattedFile = {
  name: string | null;
  path?: string | null;
  base64String: string | null;
  type: string | null;
};

export enum EFilterStatusType {
  IN_REVIEW = "IN_REVIEW",
}

export enum EApprovalStatus {
  APPROVED = "ApprovalStatus.APPROVED",
  REJECTED = "ApprovalStatus.REJECTED",
  PENDING = "ApprovalStatus.PENDING",
}

export enum EAttachmentType {
  EMPLOYEE_CONSENT = "AttachmentType.EMPLOYEE_CONSENT",
  SALARY_DEDUCTION = "AttachmentType.SALARY_DEDUCTION",
  NORMAL = "AttachmentType.NORMAL",
}
export enum EPaymentType {
  DIRECT_PAYMENT = "PaymentType.DIRECT_PAYMENT",
  PREMIUMCOLLECTION = "PaymentType.PREMIUMCOLLECTION",
  SALARY_DEDUCTION = "PaymentType.SALARY_DEDUCTION",
}

export interface IInitChatBotDocuments {
  DocumentPath: string;
  LastModifiedAt: string;
  Users: { Id: string; Name: string }[];
}
export interface IBackendError {
  statusCode: number;
  errorCode: string;
  type: string;
  correlationID: string;
  messageCode: string;
  messageVariables: any[];
  statusDescription: string;
  message: string;
  formatedMessage: string;
  exceptionMessage: string;
  stackTrace: string;
}

export type FilterItem = {
  [key: string]: {
    id: string;
    name: string;
  }[];
};

export enum EBenefitContentTab {
  all = "all",
  eligible = "eligible",
  enrolled = "enrolled",
  offerings = "offering",
  expired = "expired",
}

export enum ECompanyContentTab {
  details = "details",
  documents = "documents",
}

export enum EProfileTab {
  info = "info",
  dependents = "dependents",
  documents = "documents",
  consents = "consents",
}

export interface ITaxonomy extends Partial<components["schemas"]["TaxonomyData"]> {}

export interface IClient extends Partial<components["schemas"]["ClientB2C"]> {
  salaryDeductionConsentDocumentPath?: string;
}
export interface IEmployee extends Partial<components["schemas"]["Employee"]> {
  employeeLoginEmailAddress?: string;
}

export interface IDependent extends Partial<components["schemas"]["EmployeeDependent"]> {}

export interface ICompanyPackageView extends Partial<components["schemas"]["BenefitPackageView"]> {}

export interface IDocuments extends Partial<components["schemas"]["Attachment"]> {
  isSalaryDeduction?: boolean;
}

export interface ICardBenefitPackage extends ICompanyPackageView {
  enrolled?: boolean;
  isDependent?: boolean;
  employeeLoginEmailAddress?: string;
  employeeDependentTag?: number;
  cancellationPossibility?: string;
  employeeEnrollmentTag?: number;
  dateOfCancellation?: string;

  dateOfEnrollment?: string;
  dateOfEligibility?: string;
  endDateOfEligibility?: string;
  enrollmentDocuments?: IDocuments[];
  approveEnrollStatusCode?: EApprovalStatus;
  cancelEnrollApprovalStatusCode?: EApprovalStatus;
  rejectionComment?: string;
  //

  insurerConsentDocumentName?: string;
  insurerConsentDocumentContent?: string;
  insurerConsentDocumentMimeType?: string;

  isGrECoSensitiveDataConsentGiven?: boolean;
  consentsNeeded?: boolean;
}
export interface IEmployeeEnrollment extends Partial<components["schemas"]["EmployeeEnrollment"]> {}

export interface IChatbotMessageHistory extends Partial<components["schemas"]["MessageHistory"]> {}

export interface IChatbotMessage extends Partial<components["schemas"]["ChatBotRequest"]> {
  UserId: string;
  ForUserId: string;
}

export interface IAttachment extends Partial<components["schemas"]["Attachment"]> {}

export interface ITabProps {
  id: string;
  name: string;
  icon?: React.ReactElement;
}
